function filterGrid(cat, btn) {
    // ボタン active 切り替え
    document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    // カード表示切り替え（2026SSグリッドのみ）
    const cards = document.querySelectorAll('#grid-2026ss .card');
    cards.forEach(card => {
      if (cat === 'all' || card.dataset.cat === cat) {
        card.style.display = '';
      } else {
        card.style.display = 'none';
      }
    });
  }